module.exports = __webpack_public_path__ + "src/assets/images/volums/wind_speed/volum_circle10.png?76531bc613cc03f6bceb8fe4df75aceb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volums/wind_speed/volum_circle10.png
// module id = 853
// module chunks = 0